import { render, staticRenderFns } from "./CardOrcamento.vue?vue&type=template&id=31703798&scoped=true&"
import script from "./CardOrcamento.vue?vue&type=script&lang=js&"
export * from "./CardOrcamento.vue?vue&type=script&lang=js&"
import style0 from "./CardOrcamento.vue?vue&type=style&index=0&id=31703798&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31703798",
  null
  
)

export default component.exports